import { advancementTypes, eagleScoutRankId } from '../constants';

export default (adv: { advancementType: string; id: number }) =>
  adv.advancementType === advancementTypes.RANKS && adv.id == eagleScoutRankId;
